import { Stack } from "@mui/material";
import { SenecButton } from "src/newsenec-ui-components";

export interface SenecSignatureDialogButtonsProps {
    clearButtonText: string;
    saveButtonText: string;
    onClear: () => void;
    onSave: () => void;
}

export const SenecSignatureDialogButtons = ({
    clearButtonText,
    saveButtonText,
    onClear,
    onSave,
}: SenecSignatureDialogButtonsProps) => {
    return (
        <Stack direction={"row"} justifyContent={"right"} width={"100%"} gap={2}>
            <SenecButton level="secondary" size="small" onClick={onClear} data-testid={"clear-btn"}>
                {clearButtonText}
            </SenecButton>
            <SenecButton size="small" onClick={onSave} data-testid={"save-btn"}>
                {saveButtonText}
            </SenecButton>
        </Stack>
    );
};
